export default __webpack_public_path__ + "static/media/tutorialImageMobile.347dd9fc.png";